import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';
import { selectCommonInfoLoanApplication } from './loanApplicationCommonInfo.selectors';
import { selectLoanApplicationSubjectPropertyState } from './loanApplicationProperties.selectors';

const selectStateSigningRequirements = createSelector(
  selectLoanApplication,
  ({ stateSigningRequirements }) => stateSigningRequirements,
);

export const selectIsSpouseSignatureIsRequired = createSelector(
  [
    selectStateSigningRequirements,
    selectLoanApplicationSubjectPropertyState,
    selectCommonInfoLoanApplication,
  ],
  (stateSigningRequirements, subjectPropertyState, { loanPurpose }) => {
    const signingRequirement = stateSigningRequirements[subjectPropertyState]?.find(
      requirement => requirement.loanPurpose === loanPurpose,
    );

    return !!signingRequirement?.spouseMustSign;
  },
);
